const storeName = 'display-elevator'

export const elevator = {
    namespaced: true,
    state: {
        overviewSearch: localStorage.getItem(storeName + '-overview'),
        pdfOverviewSearch: localStorage.getItem(storeName + '-pdf-overview'),
    },
    mutations: {
        storeElevatorOverviewSearch(state, search) {
            state.overviewSearch = search;
            localStorage.setItem(storeName + '-overview', search ? search : '');
        },
        storePdfOverviewSearch(state, search) {
            state.pdfOverviewSearch = search;
            localStorage.setItem(storeName + '-pdf-overview', search ? search : '');
        }
    }
}